import React from 'react';
import Segmented from '../common/Segmented';
import { formatLongDate, formatTime } from '../../utils/date';
import { pluralize } from '../../utils/format';

/** Morning / Afternoon / Evening tabs with a 3-column slot grid. Taken slots are struck through. */
export default function TimeSlotPicker({
  date, periods, period, onPeriodChange, selectedTime, onSelectTime, totalOpen, loading,
}) {
  const current = periods.find((p) => p.key === period) || periods[0];
  return (
    <section className="slot-picker">
      <div className="slot-picker__head">
        <h2 className="booking__label">
          Time
          {date && <span className="booking__label-sub">{` · ${formatLongDate(date)}`}</span>}
        </h2>
        {!loading && date && <span className="slot-picker__count">{`${pluralize(totalOpen, 'slot')} open`}</span>}
      </div>
      <Segmented
        ariaLabel="Time of day"
        value={period}
        onChange={onPeriodChange}
        items={periods.map((p) => ({ key: p.key, label: p.label, sub: `${p.range} · ${p.open} open` }))}
      />
      {loading ? (
        <div className="slot-grid">
          {Array.from({ length: 6 }, (_, i) => <div key={i} className="skeleton slot" />)}
        </div>
      ) : (
        <div className="slot-grid">
          {current.slots.map((s) => (
            <button
              key={s.time}
              type="button"
              className={`slot ${selectedTime === s.time ? 'slot--selected' : ''}`}
              disabled={!s.available}
              onClick={() => onSelectTime(s.time)}
              aria-pressed={selectedTime === s.time}
            >
              {formatTime(s.time)}
            </button>
          ))}
          {!current.slots.length && <p className="u-muted slot-grid__empty">No times in this period.</p>}
        </div>
      )}
    </section>
  );
}
